const prepareSearchTerm = (searchTerm) => searchTerm.replace(/[^\p{L}\p{N}\s&"'-]/gu, '').trim();

export default prepareSearchTerm;
